import PropTypes from 'prop-types'
import React from 'react'
import {
  Badge
} from 'react-bootstrap'
import {
  ModalMenu
} from 'components/Modal'
import {
  MenuItem as ModalMenuItem
} from 'components/Menu'
import KanBoIcon from 'components/KanBoIcon'
import classes from '../../Sidebar.module.scss'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'

export class MenuItem extends React.Component {
  static propTypes = {
    hideMenuOnClick: PropTypes.bool.isRequired,

    leftSidebar: PropTypes.object.isRequired,

    setIsSidebarVisible: PropTypes.func.isRequired,
  }

  static defaultProps = {
    hideMenuOnClick: true,
  }

  setView = (view) => {
    this.props.leftSidebar.push(view, { position: 'left' })
  }

  handleBadgeClick = (event) => {
    const { onBadgeClick } = this.props

    if (onBadgeClick) {
      event.stopPropagation()

      onBadgeClick(event)
    }
  }

  renderMenu () {
    const { menu } = this.props

    return !!menu && (
      <ModalMenu>
        <span
          className={classes.menuIcon}
        >
          <KanBoIcon name='kanbo-16-options' />
        </span>
        {Array.isArray(menu)
          ? menu.map((menuItem, index) => {
            if (React.isValidElement(menuItem)) {
              return menuItem
            }

            const { title, ...menuItemProps } = menuItem

            return (
              <ModalMenuItem
                {...menuItemProps}
                key={index}
              >
                {title}
              </ModalMenuItem>
            )
          })
          : menu
        }
      </ModalMenu>
    )
  }

  render () {
    const {
      leftSidebar,

      hideMenuOnClick,

      icon,
      title,
      content,
      actions,
      badge,
      onBadgeClick,
      view,
      selected,
      href,
      className,
      onClick,

      setIsSidebarVisible,

      ...props
    } = this.props

    const itemProps = {}

    if (!content) {
      if (view) {
        itemProps.onClick = () => {
          this.setView(view)
        }
      } else if (onClick) {
        itemProps.onClick = (event) => {
          if (window.innerWidth <= 767 && hideMenuOnClick) {
            setIsSidebarVisible(false)
          }

          onClick(event, this.setView)
        }
      }
    }

    let compClassName = classes.menuItem
    if (itemProps.onClick) compClassName += ' ' + classes.clickable
    if (selected) compClassName += ` ${classes.selected}`
    if (href) compClassName += ' clear-link-style'
    if (title) compClassName += ` ${classes.withTitle}`
    if (className) compClassName += ` ${className}`

    const Tag = href ? 'a' : 'div'

    return (
      content ? (
        content(this.setView)
      ) : (
        <Tag
          {...props}
          {...itemProps}
          href={href}
          className={compClassName}
        >
          <span className={classes.menuItemTitleWrapper}>
            {!!icon &&
              <span className={classes.menuItemIcon}>
                {icon}
              </span>
            }
            <span className={classes.menuItemTitle}>
              {title}
            </span>
            {actions}
            {this.renderMenu()}
            {!!badge && (
              <Badge
                className={`${classes.menuItemBadge}${onBadgeClick ? ` ${classes.clickable}` : ''}`}
                onClick={this.handleBadgeClick}
              >
                {badge}
              </Badge>
            )}
          </span>
        </Tag>
      )
    )
  }
}

export default withLeftSidebar(MenuItem)
